module.exports = __webpack_public_path__ + "img/icon_Quality-Inputs.f32821b2.svg";